function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Fragment, useCallback, useState, useRef } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Text from '../../2/Text';
import { useEventCallback } from './utils';
import { transitionConfig } from '../Form/SharedBaseComponents';

function findClosest(values, currentValue) {
  var _values$reduce = values.reduce(function (acc, value, index) {
    var distance = Math.abs(currentValue - index);

    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance: distance,
        index: index
      };
    }

    return acc;
  }, null),
      closestIndex = _values$reduce.index;

  return closestIndex;
}

function focusThumb(_ref) {
  var sliderRef = _ref.sliderRef,
      activeIndex = _ref.activeIndex;

  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
    sliderRef.current.querySelector("[data-index=\"".concat(activeIndex, "\"]")).focus();
  }
}

function trackFinger(event, touchId) {
  if (touchId.current !== undefined && event.changedTouches) {
    for (var i = 0; i < event.changedTouches.length; i += 1) {
      var touch = event.changedTouches[i];

      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }

    return false;
  }

  return {
    x: event.clientX,
    y: event.clientY
  };
}

function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}

function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}

var SliderContainer = styled.span.withConfig({
  displayName: "Slider__SliderContainer",
  componentId: "sc-y3ff09-0"
})(["height:0.25rem;width:100%;box-sizing:content-box;padding:0.75rem 0;display:inline-block;position:relative;cursor:pointer;touch-action:none;"]);
export var Rail = styled.span.withConfig({
  displayName: "Slider__Rail",
  componentId: "sc-y3ff09-1"
})(["display:block;position:absolute;width:100%;height:0.25rem;border-radius:0.125rem;outline:none;opacity:", ";background-color:", ";"], function (_ref2) {
  var isNumerical = _ref2.isNumerical;
  return isNumerical ? 0.08 : 1;
}, function (_ref3) {
  var isNumerical = _ref3.isNumerical,
      theme = _ref3.theme;
  return isNumerical ? theme.colors.iconDefault : theme.colors.bgAlternate;
});
export var CompletedRail = styled.span.withConfig({
  displayName: "Slider__CompletedRail",
  componentId: "sc-y3ff09-2"
})(["display:block;position:absolute;height:0.25rem;border-radius:0.125rem;outline:none;background-color:", ";left:0;", ""], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.bgAlternate;
}, function (_ref5) {
  var percent = _ref5.percent;
  return css(["width:", "%;"], percent);
});
var Mark = styled.span.withConfig({
  displayName: "Slider__Mark",
  componentId: "sc-y3ff09-3"
})(["display:", ";position:absolute;width:0.125rem;height:0.25rem;opacity:", ";background-color:", ";", ""], function (_ref6) {
  var percent = _ref6.percent;
  return percent === 0 || percent === 100 ? 'none' : 'inline-block';
}, function (_ref7) {
  var isNumerical = _ref7.isNumerical;
  return isNumerical ? 0.2 : 1;
}, function (_ref8) {
  var theme = _ref8.theme,
      isNumerical = _ref8.isNumerical;
  return isNumerical ? theme.colors.iconDefault : theme.colors.bgPrimary;
}, function (_ref9) {
  var percent = _ref9.percent;
  return css(["left:", "%;"], percent);
});
var MarkLabel = styled.span.withConfig({
  displayName: "Slider__MarkLabel",
  componentId: "sc-y3ff09-4"
})(["display:", ";position:absolute;top:", ";transform:translateX(-50%);white-space:nowrap;", ""], function (_ref10) {
  var showLabel = _ref10.showLabel;
  return showLabel ? 'inline-block' : 'none';
}, function (_ref11) {
  var labelOnTop = _ref11.labelOnTop;
  return labelOnTop ? '-2rem' : '2rem';
}, function (_ref12) {
  var percent = _ref12.percent;
  return css(["left:", "%;"], percent);
});
export var Thumb = styled.span.withConfig({
  displayName: "Slider__Thumb",
  componentId: "sc-y3ff09-5"
})(["display:flex;position:absolute;align-items:center;justify-content:center;margin-left:-0.875rem;margin-top:-0.875rem;width:2rem;height:2rem;border-radius:50%;border:0.25rem solid ", ";background-color:", ";box-shadow:0 1px 6px 0 rgba(0,0,0,0.2);transition:box-shadow ", ",background-color 0.15s;outline:none;box-sizing:border-box;", " &:focus-within{box-shadow:", ";}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.iconInverted;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.bgAlternate;
}, transitionConfig, function (_ref15) {
  var percent = _ref15.percent;
  return css(["left:", "%;"], percent);
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.shadows.input;
});
/** @component */

var Slider = function Slider(props) {
  var ariaLabelledby = props.ariaLabelledby,
      defaultStepIndex = props.defaultStepIndex,
      handleCurrentStep = props.handleCurrentStep,
      steps = props.steps,
      name = props.name,
      showCurrentStepLabelOnly = props.showCurrentStepLabelOnly,
      labelOnTop = props.labelOnTop;
  var min = 0;
  var max = steps.length ? steps.length - 1 : 1;
  var touchId = useRef();
  var sliderRef = useRef();

  var _useState = useState(defaultStepIndex),
      _useState2 = _slicedToArray(_useState, 2),
      currentStepIndex = _useState2[0],
      _setCurrentStep = _useState2[1];

  var setCurrentStep = function setCurrentStep(index) {
    _setCurrentStep(index);

    handleCurrentStep(index);
  };

  var handleKeyDown = useEventCallback(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    var newValue;

    switch (event.key) {
      case 'ArrowRight':
        newValue = index >= steps.length - 1 ? steps.length - 1 : index + 1;
        break;

      case 'ArrowLeft':
        newValue = index === 0 ? 0 : index - 1;
        break;

      default:
        return;
    }

    event.preventDefault();
    setCurrentStep(newValue);
  });
  var getFingerNewValue = useCallback(function (_ref17) {
    var finger = _ref17.finger;
    var slider = sliderRef.current;

    var _slider$getBoundingCl = slider.getBoundingClientRect(),
        width = _slider$getBoundingCl.width,
        left = _slider$getBoundingCl.left;

    var percent = (finger.x - left) / width;
    var newValue = percentToValue(percent, min, max);
    newValue = findClosest(steps, newValue);
    return {
      newValue: newValue
    };
  }, [steps, max]);
  var handleTouchStart = useEventCallback(function (event) {
    // Workaround as Safari has partial support for touchAction: 'none'.
    event.preventDefault();
    var touch = event.changedTouches[0];

    if (touch != null) {
      // A number that uniquely identifies the current finger in the touch session.
      touchId.current = touch.identifier;
    }

    var finger = trackFinger(event, touchId);

    var _getFingerNewValue = getFingerNewValue({
      finger: finger
    }),
        newValue = _getFingerNewValue.newValue;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: currentStepIndex
    });
    setCurrentStep(newValue);
  });
  var handleMouseEnter = useEventCallback(function (event) {
    // If the slider was being interacted with but the mouse went off the window
    // and then re-entered while unclicked then end the interaction.
    if (event.buttons === 0) {
      handleTouchEnd(event);
    }
  });
  var handleTouchEnd = useEventCallback(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    touchId.current = undefined;
    document.body.removeEventListener('mousemove', handleTouchMove);
    document.body.removeEventListener('mouseup', handleTouchEnd);
    document.body.removeEventListener('mouseenter', handleMouseEnter);
  });
  var handleTouchMove = useEventCallback(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue2 = getFingerNewValue({
      finger: finger
    }),
        newValue = _getFingerNewValue2.newValue;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: currentStepIndex
    });
    setCurrentStep(newValue);
  });
  React.useEffect(function () {
    var slider = sliderRef.current;
    slider.addEventListener('touchstart', handleTouchStart);
    slider.addEventListener('touchmove', handleTouchMove);
    slider.addEventListener('touchend', handleTouchEnd);
    return function () {
      slider.removeEventListener('touchstart', handleTouchStart);
      slider.removeEventListener('touchmove', handleTouchMove);
      slider.removeEventListener('touchend', handleTouchEnd);
      document.body.removeEventListener('mousemove', handleTouchMove);
      document.body.removeEventListener('mouseup', handleTouchEnd);
      document.body.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, [handleMouseEnter, handleTouchEnd, handleTouchMove, handleTouchStart]);
  var handleMouseDown = useEventCallback(function (event) {
    event.preventDefault();
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue3 = getFingerNewValue({
      finger: finger
    }),
        newValue = _getFingerNewValue3.newValue;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: currentStepIndex
    });
    setCurrentStep(newValue);
    document.body.addEventListener('mousemove', handleTouchMove);
    document.body.addEventListener('mouseup', handleTouchEnd);
    document.body.addEventListener('mouseenter', handleMouseEnter);
  });
  var currentPercent = valueToPercent(currentStepIndex, min, max);
  var currentStepLabel = steps[currentStepIndex].label;
  return /*#__PURE__*/React.createElement(SliderContainer, {
    ref: sliderRef,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/React.createElement(Rail, {
    isNumerical: props.isNumerical
  }), /*#__PURE__*/React.createElement("input", {
    value: currentStepIndex,
    name: name,
    type: "hidden"
  }), steps.map(function (step, index) {
    var percent = valueToPercent(index, min, max);
    return /*#__PURE__*/React.createElement(Fragment, {
      key: step.value
    }, /*#__PURE__*/React.createElement(Mark, {
      percent: percent,
      isNumerical: props.isNumerical
    }), /*#__PURE__*/React.createElement(MarkLabel, {
      "aria-hidden": true,
      showLabel: showCurrentStepLabelOnly ? currentStepIndex === index ? true : false : step.showLabel,
      percent: percent,
      labelOnTop: labelOnTop
    }, /*#__PURE__*/React.createElement(Text.Label18, null, step.label)));
  }), props.isNumerical && /*#__PURE__*/React.createElement(CompletedRail, {
    percent: currentPercent
  }), /*#__PURE__*/React.createElement(Thumb, {
    tabIndex: 0,
    "aria-label": currentStepLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-valuetext": currentStepLabel,
    "aria-valuenow": currentStepIndex,
    "data-index": currentStepIndex,
    percent: currentPercent,
    role: "slider",
    onKeyDown: handleKeyDown
  }));
};

var propTypes = {
  /**
   * Hidden input name
   */
  name: PropTypes.string,

  /**
   * Id of the associated label
   */
  ariaLabelledby: PropTypes.string,

  /**
   * Default step index for the initial render
   */
  defaultStepIndex: PropTypes.number,

  /**
   * Callback for the new step setter
   */
  handleCurrentStep: PropTypes.func,

  /**
   * Steps array
   */
  showCurrentStepLabelOnly: PropTypes.bool,

  /**
   * Show only current step label
   */
  labelOnTop: PropTypes.bool,

  /**
   * Show label above the Slider
   */
  steps: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    showLabel: PropTypes.bool
  }))
};
Slider.propTypes = propTypes;
Slider.defaultProps = {
  defaultStepIndex: 0,
  steps: [],
  name: 'slider-input',
  showCurrentStepLabelOnly: false,
  labelOnTop: false
};
export default Slider;